import ApiClient from './ApiClient';

class CsatSurveysAPI extends ApiClient {
  constructor() {
    super('csat_surveys', { accountScoped: true });
  }
}

export default new CsatSurveysAPI();
